import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { CommunicationTemplateDto, ResponseDto } from "@mimber/schema"
import { communicationTemplatesKeys } from "../communication-templates.utils"

export const useCommunicationTemplate = (
  uuid: string,
  options?: UseQueryOptions<ResponseDto<CommunicationTemplateDto>, Error>
): UseQueryResult<ResponseDto<CommunicationTemplateDto>, Error> => {
  guardAppUsage("mimber-organization", "useCommunicationTemplate")

  const { server } = useServerContext()

  return useQuery({
    queryKey: communicationTemplatesKeys.findOne(uuid),
    queryFn: async () => {
      const response = await server.get<ResponseDto<CommunicationTemplateDto>>(
        `communication-templates/${uuid}`
      )
      return response.data
    },
    staleTime: 1 * 60 * 1000,
    enabled: !!uuid,
    ...options,
  })
}
